@if (tour.photosCount === 0 || !isPhotoSliderAvailable) {
    <div class="ng-container">
        <div class="ng-image" [style.background-image]="'url(' + mainPhotoSrc + ')'"></div>
        <span class="ng-image-count">{{ tour.photosCount }}</span>

        @if (tour.isCombined) {
            <span class="ng-label-combined">{{ messages.combiTour }}</span>
        }
        @if (!isShowDiscount && !tour.discount && !tour.isCombined) {
            <span class="ng-discount">-{{ tour.discount }}%</span>
        }

        @if (tour.isRecommended) {
            <app-tour-recommendations [tour]="tour" [open$]="open$"></app-tour-recommendations>
        } @else {
            <span *ngIf="tour.salesCount" class="ng-sales-count">
                {{ messages.tourPurchased | template: tourPurchasedMapping(tour.salesCount) }}
            </span>
        }
    </div>
} @else {
    <div class="ng-container">
        <div #swiperContainer class="ng-image" [style.background-image]="'url(' + mainPhotoSrc + ')'">
            @if (isPhotoLoading) {
                <div class="swiper-lazy-custom-preloader">
                    <div class="loader"></div>
                </div>
            }

            @if (isPhotosLoaded) {
                <div class="ng-swapper-container">
                    <div #swiperGallery class="swiper">
                        <div class="swiper-wrapper">
                            @for (photo of imageCollection; track $index) {
                                <div class="swiper-slide">
                                    <img [src]="photo" class="ng-swipper-image" alt="">
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            @if (tour.photosCount > 1) {
                <div class="ng-swiper-bullets">
                    <div class="ng-swiper-bullets-track" #swiperBullets></div>
                </div>
            }
        </div>
        <span class="ng-image-count">{{ tour.photosCount }}</span>

        @if (tour.isCombined) {
            <span class="ng-label-combined">{{ messages.combiTour }}</span>
        }

        @if (isShowDiscount && tour.discount && !tour.isCombined) {
            <span class="ng-discount">-{{ tour.discount }}%</span>
        }

        @if (tour.isRecommended) {
            <app-tour-recommendations [tour]="tour" [open$]="open$"></app-tour-recommendations>
        } @else {
            @if (tour.salesCount) {
                <span class="ng-sales-count">
                    {{ messages.tourPurchased | template: tourPurchasedMapping(tour.salesCount) }}
                </span>
            }
        }
    </div>
}
